import {
  ArrowToLeft,
  ArrowToRightIcon,
  GridLayoutIconRent,
  MapLineIconRent,
  NUSDIcon,
  PinLocationIconRent,
  ShortRentalIcon,
} from "../../AssetComponents/Images";
import { Popover } from "react-tiny-popover";
import { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import propertyService from "../../Services/PropertyService";
import {
  selectAllProperties,
  selectFilteredProperties,
  selectVisibleProperties,
  selectIsLoading,
  selectIsPreloading,
  selectHasMoreProperties,
  selectIsCacheValid,
  loadMoreProperties,
  setFilteredProperties,
  setSearchResults,
  clearSearchResults,
  resetPagination,
} from "../../ReduxSlices/RentalPropertySlice";
import { mapStyles } from "../../Components/GoogleMap/Style";
import {
  MapShareIcon,
  MapPlusIcon,
  MapMinusIcon,
} from "../../AssetComponents/Images";
import Modal from "react-responsive-modal";
import { GoogleMap, OverlayView, Marker } from "@react-google-maps/api";
import mapPinIcon from "../../assets/images/Dashboard/Dashboard/mappin.svg";
import "react-range-slider-input/dist/style.css";
import { setPriceRange } from "../../ReduxSlices/SearchSlice";

import { api } from "../../Components/functions/Apiwithouttoken";
import { RentalItem } from "../../Components/RealEstateProperty/RentalItem";
import { MiniRentalItem } from "../../Components/RealEstateProperty/MiniRentalItem";
import initialLoadOptimizer from "../../Services/InitialLoadOptimizer";
import { RentalNavigation } from "../../Components/Rent/RentalNavigationComponent";
import { RentalSearch } from "../../Components/Rent/Search";
import Listings from "../../Components/Rent/Listings";
import HomeIcons from "../../Components/Rent/HomeIcons";
import Filter from "../../Components/Rent/Filter";
import Chatbot from "../../Components/Chatbot/Chatbot";
import { PropertySkeletonGrid } from "../../Components/RealEstateProperty/PropertySkeleton";
import { PurpleButton } from "../../Components/Buttons/PurpleButton";
import { BlackButton } from "../../Components/Buttons/BlackButton";
import { RentMobile } from "./RentMobile";
import { isMobileDevice } from "../../utils/deviceDetection";
import { normalizePricePerDay, hasValidLocation, getSafeLocation } from "../../utils/propertyValidation";

export const Rent = () => {
  // Check if device is mobile
  const [isMobile, setIsMobile] = useState(false);

  // All hooks must be called before any conditional returns
  const [showMapMenu, setShowMapMenu] = useState(false);
  const navigate = useNavigate();
  const account = useSelector((state) => state.auth.account);
  const reservation_period = useSelector((state) => state.reservation.period);
  const guests = useSelector((state) => state.reservation.guests);
  
  // Use Redux state instead of local state
  const properties = useSelector(selectAllProperties);
  const filteredProperties = useSelector(selectFilteredProperties);
  const visibleProperties = useSelector(selectVisibleProperties);
  const loading = useSelector(selectIsLoading);
  const isPreloading = useSelector(selectIsPreloading);
  const hasMoreProperties = useSelector(selectHasMoreProperties);
  const isCacheValid = useSelector(selectIsCacheValid);
  
  const [sortType, setSortType] = useState("default");

  const location = useLocation();
  const dispatch = useDispatch();
  const [zoom, setZoom] = useState(10);
  const [activeToken, setActiveToken] = useState();
  const [fullScreen, setFullScreen] = useState(false);
  const [hideMap, setHideMap] = useState(false);
  const range = useSelector((state) => state.search.priceRange);
  const [pinLocation, setPinLocation] = useState({
    lat: 25,
    lng: 55,
  });
    const [isSearchResult, setIsSearchResult] = useState(false);
  const [hasLocationInSearch, setHasLocationInSearch] = useState(true); // Track if location was specified in search
  const [showWaitlistModal, setShowWaitlistModal] = useState(false);
  const [waitlistData, setWaitlistData] = useState({ name: '', email: '' });    
  const [waitlistLoading, setWaitlistLoading] = useState(false);
  const amenities = useSelector((state) => state.search.amenities);
  const propertyType = useSelector((state) => state.search.propertyType);
  const instantBook = useSelector((state) => state.search.instantBook);
  const allowPets = useSelector((state) => state.search.allowPets);

  // All hooks must be called before any conditional returns
  const handleLoadMoreProperties = useCallback(() => {
    if (hasMoreProperties && !loading) {
      dispatch(loadMoreProperties());
    }
  }, [hasMoreProperties, loading, dispatch]);

  const handleSelectMapPin = async (pinLocation) => {
    // setAddressInput(res.results[0].formatted_address);
  };

  // Intersection Observer for infinite scroll
  const observerTarget = useRef(null);

  const loadProperties = useCallback(async (forceRefresh = false) => {
    try {
      console.log('Rent.js - Loading properties...', { forceRefresh, isCacheValid });
      await propertyService.loadProperties(dispatch, { 
        forceRefresh, 
        useCache: !forceRefresh 
      });
      console.log('Rent.js - Properties loaded successfully');
    } catch (error) {
      console.error('Rent.js - Failed to load properties:', error);
    }
  }, [dispatch, isCacheValid]);

  // Mobile detection effect
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(isMobileDevice() || window.innerWidth < 1024);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    handleSelectMapPin(pinLocation);
  }, [pinLocation]);

  useEffect(() => {
    if (!range?.max)
      dispatch(
        setPriceRange({
          min: range?.min || 1,
          max: 10000,
        })
      );
    if (!range?.min)
      dispatch(
        setPriceRange({
          min: 1,
          max: range?.max || 10000,
        })
      );
  }, [range, dispatch]);

  useEffect(() => {
    // Only load properties on initial mount if not already cached
    // DISABLED: No auto-refresh when cache expires - only load if we have no properties
    if (properties.length === 0) {
      loadProperties();
    } else {
      console.log('Rent.js - Using cached properties');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Only run on mount, not when cache validity changes

  // Aggressive preloading for initial load
  useEffect(() => {
    if (properties.length > 0) {
      console.log('🚀 Starting aggressive preloading for initial load...');
      
      // Preload above-the-fold images immediately
      initialLoadOptimizer.preloadAboveTheFold(properties);
      
      // Preload background images after a short delay
      setTimeout(() => {
        initialLoadOptimizer.preloadBackgroundImages(properties);
      }, 1000);
    }
  }, [properties]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (
          entries[0].isIntersecting &&
          !loading &&
          hasMoreProperties
        ) {
          handleLoadMoreProperties();
        }
      },
      { threshold: 0.1 }
    );

    if (observerTarget.current) {
      observer.observe(observerTarget.current);
    }

    return () => observer.disconnect();
  }, [loading, hasMoreProperties, handleLoadMoreProperties]);


  // Debug effect to monitor filtering
  useEffect(() => {
    console.log('Rent.js - Filtering Debug:', {
      totalProperties: properties.length,
      filteredProperties: filteredProperties.length,
      visibleProperties: visibleProperties.length,
      account: account,
      isConnected: !!account
    });
  }, [properties, filteredProperties, visibleProperties, account]);
  
  // Enforce price visibility ($25 to $15,000) AND islisted === true
  // Use normalized price to handle both raw and converted formats
  const MIN_VISIBLE_PRICE = 25;
  const MAX_VISIBLE_PRICE = 15000;
  const eligibleVisibleProperties = (visibleProperties || []).filter(
    (p) => {
      // ✅ FIX: Check if property is listed
      if (!p?.short || p.short.islisted !== true) return false;
      
      // ✅ FIX: Check price range
      const price = normalizePricePerDay(p?.short?.price_per_day || 0);
      if (price < MIN_VISIBLE_PRICE || price > MAX_VISIBLE_PRICE) return false;
      
      return true;
    }
  );
  const eligibleFilteredProperties = (filteredProperties || []).filter(
    (p) => {
      // ✅ FIX: Check if property is listed
      if (!p?.short || p.short.islisted !== true) return false;
      
      // ✅ FIX: Check price range
      const price = normalizePricePerDay(p?.short?.price_per_day || 0);
      if (price < MIN_VISIBLE_PRICE || price > MAX_VISIBLE_PRICE) return false;
      
      return true;
    }
  );
  
  // Map properties: Show the SAME properties as the list view (eligibleVisibleProperties)
  // This ensures the map shows exactly what's visible in the list panel
  // Filter to only include properties with valid location data
  const mapProperties = (eligibleVisibleProperties || []).filter((nft) => {
    // Use helper function to validate location coordinates (not 0, valid numbers, within bounds)
    return hasValidLocation(nft);
  });
  
  // Debug logging for map properties
  useEffect(() => {
    const visibleWithLocation = (eligibleVisibleProperties || []).filter(p => hasValidLocation(p));
    const visibleWithoutLocation = (eligibleVisibleProperties || []).filter(p => !hasValidLocation(p));
    
    // 🔍 Debug: Check for invalid properties (price 0 or not listed)
    const invalidProperties = (visibleProperties || []).filter(p => {
      const price = normalizePricePerDay(p?.short?.price_per_day || 0);
      const isListed = p?.short?.islisted === true;
      return price < MIN_VISIBLE_PRICE || price > MAX_VISIBLE_PRICE || !isListed;
    });
    
    if (invalidProperties.length > 0) {
      console.warn('⚠️ Invalid properties found in visibleProperties:', invalidProperties.map(p => ({
        token_id: p?.token_id,
        price: normalizePricePerDay(p?.short?.price_per_day || 0),
        islisted: p?.short?.islisted,
        short: p?.short
      })));
    }
    
    console.log('🗺️ Map Properties Debug:', {
      totalProperties: properties.length,
      filteredProperties: filteredProperties.length,
      visibleProperties: visibleProperties.length,
      eligibleVisibleProperties: eligibleVisibleProperties.length,
      mapProperties: mapProperties.length,
      visibleWithLocation: visibleWithLocation.length,
      visibleWithoutLocation: visibleWithoutLocation.length,
      invalidProperties: invalidProperties.length,
      activeToken: activeToken,
      mapPropertiesDetails: mapProperties.slice(0, 20).map(p => ({
        token_id: p?.token_id,
        price: normalizePricePerDay(p?.short?.price_per_day || 0),
        location: p?.metaData?.location,
        hasValidLocation: hasValidLocation(p),
        islisted: p?.short?.islisted,
        isActive: p?.token_id === activeToken
      }))
    });
  }, [properties.length, filteredProperties.length, visibleProperties.length, eligibleVisibleProperties.length, mapProperties.length, activeToken, account]);

  // Memoize waitlist handlers before any conditional returns
  const handleJoinWaitlist = useCallback(() => {
    setShowWaitlistModal(true);
  }, []);

  const handleWaitlistSubmit = useCallback(async () => {
    if (!waitlistData.name || !waitlistData.email) {
      alert('Please fill in both name and email');
      return;
    }

    setWaitlistLoading(true);
    
    try {
      const response = await api("waitlist/add", {
        Name: waitlistData.name,
        Email: waitlistData.email
      });
      
      if (response === true) {
        alert('Successfully added to waitlist! We\'ll notify you when properties are available in your area.');
        setShowWaitlistModal(false);
        setWaitlistData({ name: '', email: '' });
      } else {
        alert('Email already exists in our waitlist or there was an error. Please try again.');
      }
    } catch (error) {
      console.error('Waitlist error:', error);
      alert('Failed to add to waitlist. Please try again.');
    } finally {
      setWaitlistLoading(false);
    }
  }, [waitlistData]);

  // Memoize the close handler to prevent unnecessary re-renders
  const handleCloseModal = useCallback(() => {
    setShowWaitlistModal(false);
  }, []);

  // Render mobile version if on mobile
  if (isMobile) {
    return <RentMobile />;
  }

    const handleSearch = async (searchResults) => {
    // Handle special country-not-available response
    if (searchResults && typeof searchResults === 'object' && searchResults.countryNotAvailable === true) {                                                     
      dispatch(setSearchResults([]));
      setIsSearchResult(true);
      // Store country info for display in waitlist message
      dispatch({ type: 'SET_COUNTRY_NOT_AVAILABLE', payload: searchResults.country });                                                                          
      return;
    }

    // Handle case where no location was specified
    if (searchResults && typeof searchResults === 'object' && searchResults.hasLocation === false) {
      dispatch(setSearchResults([]));
      setIsSearchResult(true);
      setHasLocationInSearch(false); // No location was specified
      return;
    }

    // Clear the no-location flag if we have a regular search
    setHasLocationInSearch(true); // Location was specified or it's a regular search

    if (searchResults && Array.isArray(searchResults) && searchResults.length > 0) {
      dispatch(setSearchResults(searchResults));
      setIsSearchResult(true);

      if (searchResults[0]?.metaData?.location) {
        setPinLocation({
          lat: searchResults[0].metaData.location.lat,
          lng: searchResults[0].metaData.location.lng
        });
      }
    } else {
      // Empty search results - Redux slice will clear filtered properties automatically                                                                        
      dispatch(setSearchResults([]));
      setIsSearchResult(true);
    }
  };

  const handleSort = (sortedData) => {
    if (Array.isArray(sortedData) && sortedData.length > 0) {
      console.log('Frontend Render - Properties with ratings:', 
        sortedData?.slice(0, 5).map((item, index) => ({
          index,
          token_id: item.token_id,
          price_per_day: item.short?.price_per_day,
          averageRating: item.averageRating
        }))
      );
      
      dispatch(setFilteredProperties(sortedData));
    } else {
      console.warn('Empty or invalid response received from sort:', sortedData);
      if (filteredProperties.length > 0) {
        dispatch(resetPagination());
        alert('No properties found with the selected sort criteria');
      } else {
        dispatch(setFilteredProperties([]));
      }
    }
  };

  // NEW: Handle sort type changes by triggering unified filtering
  const handleSortTypeChange = async (newSortType) => {
    try {
      console.log('Sort type changed to:', newSortType);
      
      // Get current filter state from Redux (already available in component scope)
      const currentFilters = {
        range,
        amenities,
        propertyType,
        instantBook,
        allowPets,
        guests,
        period: reservation_period,
        metaDetails: { amenities },
        properties // Pass properties for fallback
      };
      
      // Import and use the unified function
      const { getFilteredAndSortedProperties } = await import('../../Components/functions/FilterApi');
      
      const result = await getFilteredAndSortedProperties(
        currentFilters,
        newSortType,
        (results) => {
          console.log('Unified sort change returned:', results?.length || 0, 'properties');
          dispatch(setFilteredProperties(results));
        },
        () => {}, // No loading state needed for sort changes
        () => {}  // No filter modal to close
      );
      
      console.log('Sort type change completed successfully:', result);
      
    } catch (error) {
      console.error('Error handling sort type change:', error);
      
      // Fallback: apply local sorting to current filtered properties
      let sortedResults = [...filteredProperties];
      
      switch (newSortType) {
        case "lowToHigh":
          sortedResults.sort((a, b) => normalizePricePerDay(a.short?.price_per_day || 0) - normalizePricePerDay(b.short?.price_per_day || 0));
          break;
        case "highToLow":
          sortedResults.sort((a, b) => normalizePricePerDay(b.short?.price_per_day || 0) - normalizePricePerDay(a.short?.price_per_day || 0));
          break;
        case "rating":
          sortedResults.sort((a, b) => (b.averageRating || 0) - (a.averageRating || 0));
          break;
        default:
          break;
      }
      
      dispatch(setFilteredProperties(sortedResults));
    }
  };

  const handleFilterChange = (filteredResults) => {
    if (filteredResults && filteredResults.length > 0) {
      dispatch(setFilteredProperties(filteredResults));
    } else {
      dispatch(setFilteredProperties([]));
    }
  };

  const handleResetFilters = () => {
    dispatch(clearSearchResults());
    setIsSearchResult(false);
    setHasLocationInSearch(true); // Reset to default
    // Reload all properties when resetting
    loadProperties(true);
  };

    const NoResultsPrompt = ({ onResetFilters }) => (
    <div className="flex flex-col items-center justify-center text-center p-4 sm:p-6">
      <div className="space-y-4 sm:space-y-6 max-w-[90%] sm:max-w-[500px]">
        <div className="text-xl sm:text-2xl font-semibold text-gray-800">
          No properties found
        </div>
        <div className="text-base sm:text-lg text-gray-600">
          Currently, we don't have any properties for your search criteria. Try adjusting your filters or search for a different location.
        </div>
        <PurpleButton
          text="Reset"
          onClick={onResetFilters}
          className="w-auto px-6 py-3"
        />
      </div>
    </div>
  );

  return (
    <>
      <div className="flex flex-col w-full h-full">
        <div className="w-full h-full flex flex-col">
          {/* Desktop Header */}
          <div className="flex w-full items-center justify-between px-[16px] my-[20px] gap-[16px]">
            <RentalNavigation />
            <div className="flex-1 flex justify-center min-w-0">
              <RentalSearch onSearch={handleSearch} onReset={handleResetFilters} />
            </div>
            <div className="flex items-center gap-[20px] flex-shrink-0">
              <Filter
                properties={properties} 
                onFilterChange={handleFilterChange}
                currentSortType={sortType}
              />
              <Listings 
                onSort={handleSort} 
                setSortType={setSortType}
                filteredProperties={filteredProperties}
                onSortTypeChange={handleSortTypeChange}
              />
            </div>
          </div>

          {/* Main Content */}
          {(location.pathname.split("/")[2] === "short" ||
            location.pathname.split("/")[2] === "all") && (
            <>
              {/* Desktop Version */}
              <div className="flex w-full h-full max-h-[calc(100vh-200px)]">
                <div
                  className={
                    fullScreen
                      ? "w-0 hidden"
                      : (eligibleVisibleProperties.length === 0)
                      ? "w-1/2 flex flex-col h-full" 
                      : hideMap
                      ? "w-full flex flex-col h-full"
                      : "w-max flex flex-col h-full"
                  }
                >
                  <div className="flex items-center justify-between w-full px-4 py-2">
                    <div className="flex items-center flex-shrink-0">
                      <ShortRentalIcon />
                      <div className="text-[20px] sm:text-[24px] font-semibold ml-2 truncate">
                        Short-Term Rental
                      </div>
                    </div>
                    <div className="flex-shrink-0">
                      <Popover
                        isOpen={showMapMenu}
                        positions={"bottom"}
                        onClickOutside={() => setShowMapMenu(false)}
                        content={
                          <div
                            onClick={() => setShowMapMenu(false)}
                            className="mt-[10px] bg-white rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                            style={{ zIndex: 9999999 }}
                          >
                            {!fullScreen && !hideMap && (
                              <div
                                onClick={() => setHideMap(true)}
                                className="cursor-pointer hover:bg-[#f5f5f5] rounded-t-[10px] p-[8px] gap-[8px] flex items-center w-full"
                              >
                                <GridLayoutIconRent />
                                <div className="text-[#666666]">Hide Map</div>
                              </div>
                            )}
                            {!fullScreen && hideMap && (
                              <div
                                onClick={() => setHideMap(false)}
                                className="cursor-pointer hover:bg-[#f5f5f5] rounded-t-[10px] p-[8px] gap-[8px] flex items-center w-full"
                              >
                                <GridLayoutIconRent />
                                <div className="text-[#666666">Show Map</div>
                              </div>
                            )}

                            <div
                              onClick={() => {
                                setHideMap(false);
                                setFullScreen(true);
                              }}
                              className="cursor-pointer hover:bg-[#f5f5f5] rounded-b-[10px] p-[8px] gap-[8px] flex items-center w-full"
                            >
                              <PinLocationIconRent />
                              <div className="text-[#666666]">View Full Map</div>
                            </div>
                          </div>
                        }
                      >
                        <div
                          onClick={() => setShowMapMenu(true)}
                          className="hover:bg-[#f6f6f6] select-none w-max py-[4px] cursor-pointer bg-white rounded-[10px] px-[14px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                        >
                          <MapLineIconRent />
                          <div className="font-semibold text-sm sm:text-base">View Map</div>
                        </div>
                      </Popover>
                    </div>
                  </div>

                  <div className={
                    hideMap
                      ? "w-full flex flex-wrap py-[10px] gap-4 overflow-auto h-[calc(100vh-270px)] px-[20px]"
                      : (eligibleVisibleProperties.length === 0)
                      ? "w-full flex items-center justify-center py-[10px] gap-4 overflow-auto h-[calc(100vh-270px)] px-[20px]"
                      : "w-max grid 2xl:grid-cols-3 xl:grid-cols-2 lg:grid-cols-1 sm:grid-cols-1 py-[10px] gap-4 overflow-auto h-[calc(100vh-270px)] px-[20px]"
                  }>
                    {(loading || isPreloading) ? (
                      <PropertySkeletonGrid count={9} />
                    ) : (
                      <>
                        {eligibleVisibleProperties.length > 0 ? (
                          eligibleVisibleProperties.map((nft, index) => (
                             <div
                               key={index}
                               className={`w-max h-max ${
                                 activeToken === nft?.token_id ? "translate-y-[-4px]" : ""
                               } transition-all duration-300 ease-in-out`}
                               onMouseEnter={() => setActiveToken(nft?.token_id)}
                               onMouseLeave={() => setActiveToken(null)}
                             >
                               <RentalItem
                                 token_id={nft?.token_id}
                                 tokenData={nft}
                               />
                             </div>
                           ))
                         ) : (
                                                    <div className="col-span-full w-full flex items-center justify-center h-full">                                                        
                            <NoResultsPrompt onResetFilters={handleResetFilters} />
                          </div>
                        )}
                        <div ref={observerTarget} className="h-10 w-full" />
                        {hasMoreProperties && (
                          <div className="w-full flex justify-center p-4">
                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-500" />
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>

                                 {/* Desktop Map */}
                 <GoogleMap
                   center={pinLocation}
                   zoom={zoom}
                   mapContainerClassName={
                     hideMap
                       ? "w-0"
                       : (eligibleVisibleProperties.length === 0)
                       ? "relative w-1/2 mx-[10px] h-full rounded-[8px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                       : "relative w-full mx-[10px] h-full rounded-[8px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                   }
                   options={{
                     mapTypeControl: false,
                     streetViewControl: false,
                     fullscreenControl: false,
                     zoomControl: false,
                     styles: mapStyles,
                     // Improve responsiveness
                     gestureHandling: 'greedy',
                     disableDefaultUI: true,
                     clickableIcons: false,
                     // Optimize for performance
                     optimized: true,
                     // Reduce animation duration
                     animation: 0,
                     // Optimize rendering
                     draggableCursor: 'grab',
                     draggingCursor: 'grabbing',
                   }}
                 >
                  <div className="absolute top-[20px] left-[20px]">
                    <div
                      onClick={() => setFullScreen(!fullScreen)}
                      className="p-[4px] rounded-full shadow-md bg-white cursor-pointer hover:bg-[#f6f6f6]"
                    >
                      {fullScreen ? <ArrowToRightIcon /> : <ArrowToLeft />}
                    </div>
                  </div>
                                     <div className="absolute top-[20px] right-[20px] flex items-center gap-[10px]">
                     <div className="p-[4px] rounded-full hover:bg-[#000000] shadow-md bg-gradient-to-b from-[#202020c0] from-0% to-70% to-[#202020]">
                       <MapShareIcon />
                     </div>
                     <div
                       className="p-[4px] rounded-full shadow-md bg-white hover:bg-[#f6f6f6] cursor-pointer touch-manipulation"
                       onClick={(e) => {
                         e.preventDefault();
                         e.stopPropagation();
                         setZoom(zoom + 1);
                       }}
                       onTouchStart={(e) => e.preventDefault()}
                     >
                       <MapPlusIcon />
                     </div>
                     <div
                       className="p-[4px] rounded-full shadow-md bg-white hover:bg-[#f6f6f6] cursor-pointer touch-manipulation"
                       onClick={(e) => {
                         e.preventDefault();
                         e.stopPropagation();
                         setZoom(zoom - 1);
                       }}
                       onTouchStart={(e) => e.preventDefault()}
                     >
                       <MapMinusIcon />
                     </div>
                   </div>
                  {(() => {
                    // 🔧 FIX: Group properties by identical coordinates and spread them out
                    // This ensures all properties are visible even if they have the same coordinates
                    const locationGroups = {};
                    mapProperties.forEach((nft, idx) => {
                      const loc = getSafeLocation(nft);
                      if (!loc) return;
                      // Round to 6 decimal places to group nearby coordinates (within ~10cm)
                      const key = `${loc.lat.toFixed(6)},${loc.lng.toFixed(6)}`;
                      if (!locationGroups[key]) {
                        locationGroups[key] = [];
                      }
                      locationGroups[key].push({ nft, originalIndex: idx });
                    });

                    let globalIndex = 0;
                    return Object.entries(locationGroups).flatMap(([key, group]) => {
                      const baseLocation = getSafeLocation(group[0].nft);
                      if (!baseLocation) return [];

                      const offsetDegrees = 0.002; // ~200 meters spread
                      const clusterSize = Math.ceil(Math.sqrt(group.length));
                      
                      return group.map(({ nft }, groupIndex) => {
                        const row = Math.floor(groupIndex / clusterSize);
                        const col = groupIndex % clusterSize;
                        const currentIndex = globalIndex++;
                        
                        // Spread properties with same coordinates in a grid
                        const propertyLocation = {
                          lat: baseLocation.lat + (row * offsetDegrees * 0.3) - (clusterSize * offsetDegrees * 0.15),
                          lng: baseLocation.lng + (col * offsetDegrees * 0.3) - (clusterSize * offsetDegrees * 0.15)
                        };
                        
                        // Add small pixel offset for visual separation
                        const offsetX = (currentIndex % 5) * 2 - 4;
                        const offsetY = (Math.floor(currentIndex / 5) % 5) * 2 - 4;
                    
                    return (
                      <OverlayView
                        position={propertyLocation}
                        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                          key={nft?.token_id || `map-${currentIndex}`}
                          getPixelPositionOffset={(width, height) => ({
                            x: -(width / 2) + offsetX,
                            y: -height + offsetY,
                          })}
                        >
                          <div style={{ position: 'relative', zIndex: nft?.token_id === activeToken ? 1000 : 100 + currentIndex }}>
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              navigate(location.pathname + "/" + nft?.token_id);
                            }}
                            onMouseEnter={() => setActiveToken(nft?.token_id)}
                            onMouseLeave={() => setActiveToken(null)}
                            onTouchStart={(e) => {
                              e.preventDefault();
                              setActiveToken(nft?.token_id);
                            }}
                            onTouchEnd={(e) => {
                              e.preventDefault();
                              setTimeout(() => setActiveToken(null), 2000);
                            }}
                            className={
                              nft?.token_id === activeToken
                                ? "w-max px-[16px] py-[8px] rounded-[20px] bg-[#5b1dee] text-white text-center cursor-pointer touch-manipulation shadow-lg"
                                : "w-max px-[16px] py-[8px] rounded-[20px] bg-[#5b1dee] hover:bg-[#4a1ac7] text-white text-center cursor-pointer touch-manipulation shadow-md"
                            }
                            style={{ touchAction: 'manipulation' }}
                          >
                            <div className="flex items-center gap-[4px]">
                              <NUSDIcon className="w-[20px]" />
                              <div className="text-[16px] font-semibold">
                                ${normalizePricePerDay(nft?.short?.price_per_day || 0)}
                              </div>
                            </div>
                          </div>
                          {nft?.token_id === activeToken && (
                            <div 
                              className="absolute left-[-90px] top-[40px] z-[9999]"
                              style={{ zIndex: 9999 }}
                            >
                              <MiniRentalItem
                                token_id={nft?.token_id}
                                confetti={false}
                                tokenData={nft}
                              />
                            </div>
                          )}
                        </div>
                      </OverlayView>
                    );
                  });
                });
              })()}
                                         
                  <Marker
                    position={pinLocation}
                    draggable
                    onDragEnd={(e) => {
                      setPinLocation({
                        lat: e.latLng.lat(),
                        lng: e.latLng.lng(),
                      });
                    }}
                    icon={{
                      url: mapPinIcon,
                      scaledSize: new window.google.maps.Size(80, 80),
                      origin: new window.google.maps.Point(0, 0),
                      anchor: new window.google.maps.Point(40, 68),
                    }}
                  />
                </GoogleMap>
              </div>
            </>
          )}

          {/* Long Term Rental Section */}
          {location.pathname.split("/")[2] === "long" && (
            <div className="w-full h-full flex-col items-center justify-center flex max-h-[calc(100vh-200px)]">
              <div className="scale-75 sm:scale-100">
                <HomeIcons />
              </div>
              <div className="text-[#202020] text-sm sm:text-base">Coming soon</div>
            </div>
          )}
        </div>
        <div className="fixed bottom-4 right-4 z-[9999]">
          <Chatbot />
        </div>
      </div>
      <Modal
        open={showWaitlistModal}
        center
        onClose={handleCloseModal}
        classNames={{
          modal: "w-[95vw] max-w-[400px] rounded-[8px] border-[1px] border-[#E3E3E3] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]",
          overlay: "z-[9999999]",
          modalContainer: "z-[9999999]",
        }}
        styles={{
          modal: {
            zIndex: 9999999,
          },
          overlay: {
            zIndex: 9999999,
          },
        }}
        animationDuration={200}
        closeOnOverlayClick={true}
        closeOnEsc={true}
      >
        <div className="p-4 sm:p-6">
          <h2 className="text-xl sm:text-2xl font-semibold mb-3 sm:mb-4">Join Our Waitlist</h2>
          <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6">
            Be the first to know when we add properties to your desired location!
          </p>
          
          <div className="space-y-3 sm:space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Name
              </label>
              <input
                type="text"
                value={waitlistData.name}
                onChange={(e) => setWaitlistData({ ...waitlistData, name: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm sm:text-base"
                placeholder="Enter your name"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Email
              </label>
              <input
                type="email"
                value={waitlistData.email}
                onChange={(e) => setWaitlistData({ ...waitlistData, email: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm sm:text-base"
                placeholder="Enter your email"
              />
            </div>
          </div>
          
          <div className="flex gap-3 mt-4 sm:mt-6">
            <div className="flex-1">
              <BlackButton
                text="Cancel"
                onClick={handleCloseModal}
                disabled={waitlistLoading}
              />
            </div>
            <div className="flex-1">
              <PurpleButton
                text={waitlistLoading ? 'Adding...' : 'Join Waitlist'}
                onClick={handleWaitlistSubmit}
                disabled={waitlistLoading}
              />
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};